import React from 'react';
import Table from 'app/components/common/Table';
import classNames from 'classnames/bind';
import { numberWithCommas } from 'app/libs/number';
import dayjs from 'app/libs/dayjs';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import styles from './PaymentChargeCompleteLayer.module.scss';

const cx = classNames.bind(styles);

function PaymentChargeCompleteLayer({ paymentResultData, onClickPrint }) {
	const ua = useSsrUserAgent();
	const { isHistoryView, type, gateway = {} } = paymentResultData;
	const isVirtualAccountType = type === 'VIRTUAL_ACCOUNT';
	const notis = gateway?.notis?.[0] || {};

	return (
		<>
			{!isHistoryView && isVirtualAccountType && (
				<strong className={cx('txt_noti_complete')}>
					무통장 입금 요청이 완료되었습니다.
					<br />
					아래 계좌로 입금해 주세요.
				</strong>
			)}
			{!isHistoryView && !isVirtualAccountType && (
				<strong className={cx('txt_noti_complete')}>
					결제가 완료되었습니다.
					<br />
					이용해주셔서 감사합니다.
				</strong>
			)}
			<div className={cx('about_history')}>
				<div className={cx('title_wrap')}>
					{!isHistoryView && <strong className={cx('tit_history_payment')}>상세 결제내역</strong>}

					{ua().isPc && isHistoryView && (
						<button
							type="button"
							className={cx('btn_print_payment')}
							onClick={onClickPrint}
						>
							결제내역 인쇄하기
						</button>
					)}
				</div>

				<Table
					type="row"
					caption="결제내역조회"
					tableAlign="right"
				>
					<colgroup>
						<col style={{ width: '106px' }} />
						<col />
					</colgroup>
					<tbody className={cx('table_history')}>
						<tr>
							<th>결제수단</th>
							<td>{isVirtualAccountType ? '무통장입금' : '신용카드'}</td>
						</tr>
						{isVirtualAccountType ? (
							<>
								<tr>
									<th>입금계좌 번호</th>
									<td>{notis.accountNo}</td>
								</tr>
								<tr>
									<th>입금은행</th>
									<td>{notis.financeName}</td>
								</tr>
								<tr>
									<th>예금주명</th>
									<td>엔카닷컴(주)</td>
								</tr>
								<tr>
									<th>송금자명</th>
									<td>{notis.depositName}</td>
								</tr>
								{isHistoryView ? (
									<>
										<tr>
											<th>결제금액</th>
											<td>{numberWithCommas(notis.amount)}원</td>
										</tr>
										<tr>
											<th>입금일시</th>
											<td>{dayjs(gateway.applyDate).format('YYYY년 MM월 DD일')}</td>
										</tr>
									</>
								) : (
									<>
										<tr>
											<th>결제예정 금액</th>
											<td>{numberWithCommas(gateway.amount)}원</td>
										</tr>
										<tr>
											<th>입금기한</th>
											<td>{dayjs(gateway.closeDate).format('YYYY년 MM월 DD일')}</td>
										</tr>
									</>
								)}
							</>
						) : (
							<>
								<tr>
									<th>신용카드 번호</th>
									<td>{gateway.cardNo}</td>
								</tr>
								<tr>
									<th>할부기간</th>
									<td>{gateway.interestMonth > 0 ? `${gateway.interestMonth}개월` : '일시불'}</td>
								</tr>
								<tr>
									<th>결제금액</th>
									<td>{numberWithCommas(paymentResultData.amount)}원</td>
								</tr>
								<tr>
									<th>승인일시</th>
									<td>{dayjs(gateway.applyDate).format('YYYY년 MM월 DD일 HH시 mm분 ss초')}</td>
								</tr>
							</>
						)}
					</tbody>
				</Table>
			</div>
		</>
	);
}

export default PaymentChargeCompleteLayer;
